/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelSingleBillingNoPositionGet$Params {
  billing_id?: string;
}

export function apiExcelExcelSingleBillingNoPositionGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelSingleBillingNoPositionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelSingleBillingNoPositionGet.PATH, 'get');
  if (params) {
    rb.query('billing_id', params.billing_id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelSingleBillingNoPositionGet.PATH = '/api/Excel/Excel_SingleBillingNoPosition';
